"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const dayjs_1 = __importDefault(require("dayjs"));
const SuggestedMatchMetadata = (props) => {
    const { suggestedMatch } = props;
    return (react_1.default.createElement("section", { className: 'suggested-match-metadata' },
        react_1.default.createElement("p", null,
            react_1.default.createElement("span", null, "Submission Date:"),
            react_1.default.createElement("strong", null, (0, dayjs_1.default)(suggestedMatch.submissionTimestamp, 'YYYY-MM-DD HH:mm:ss ZZ')
                .toDate()
                .toLocaleString('default', { month: 'short', day: 'numeric', year: 'numeric' }))),
        react_1.default.createElement("p", null,
            react_1.default.createElement("span", null, "Submission User:"),
            react_1.default.createElement("strong", null, props.suggestedMatch.submittingUserName)),
        react_1.default.createElement("p", null,
            react_1.default.createElement("span", null, "Song Code:"),
            react_1.default.createElement("strong", null, props.suggestedMatch.currentSongCode)),
        react_1.default.createElement("p", null,
            react_1.default.createElement("span", null, "Song Writers:"),
            react_1.default.createElement("strong", null, props.suggestedMatch.workWriters && props.suggestedMatch.workWriters.split('|').join(', ')))));
};
exports.default = SuggestedMatchMetadata;
